import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { AuthGuard, PerfilGuard, LoginGuard } from './_guards';
import { AccionService } from './_services/_index';
import { FirebaseMessagingService } from './_services/firebase/firebaseMessaging.service';
import { FirebaseAuthService } from './_services/firebase/firebaseAuth.service';
import { MessagingService } from './_services/messaging.service';
import { GeneralModule } from './modules/general.module';
import { LoginModule } from './views/login/login.module';
import './libs/date_format';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HammerModule } from '@angular/platform-browser';
import { ScrapingGuard } from './_guards/scraping.guard';
@NgModule({
	imports: [
		AppRoutingModule,
		CommonModule,
		LoginModule,
		GeneralModule.forRoot(),
		MatProgressBarModule,
		HammerModule,
	],
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	providers: [
		AuthGuard,
		PerfilGuard,
		LoginGuard,
		ScrapingGuard,
		FirebaseAuthService,
		FirebaseMessagingService,
		AccionService,
		MessagingService,
	],
	entryComponents: [],
})
export class AppModule {}
